// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "AnchorLinks-module--cds--assistive-text--b8948";
export var cdsVisuallyHidden = "AnchorLinks-module--cds--visually-hidden--76592";
export var hideFeedback = "AnchorLinks-module--hide-feedback--e0572";
export var link = "AnchorLinks-module--link--c72ed";
export var list = "AnchorLinks-module--list--1eac4";
export var listSmall = "AnchorLinks-module--list--small--e49ac";
export var multipleColumns = "AnchorLinks-module--multiple-columns--9d403";
export var showFeedback = "AnchorLinks-module--show-feedback--b63d6";
export var skeleton = "AnchorLinks-module--skeleton--f0ebe";